<script>

import Layout from "../../../layouts/main";
import appConfig from "../../../../app.config";
import i18n from "@/i18n";
import Detail from "@/views/manufacturer/detail/detail";

export default {
  page: {
    title: i18n.global.t('menu.business-partner.manufacturer'),
    meta: [{
      name: "description",
      content: appConfig.description,
    },],
  },
  data() {
    return {
      manufacturerId: null,
    };
  },
  components: {
    Layout,
    Detail,
  },
  computed: {

  },
  watch: {

  },
  beforeMount() {
    this.manufacturerId = this.$route.params.id
  },

  methods: {

  },
};
</script>

<template>
  <Layout>
    <detail
        :manufacturer-id="manufacturerId"
        source="business-partner"
        account-permission-code="manufacturer.account.get"
        account-edit-permission-code="manufacturer.account.get"
        other-permission-code="manufacturer.get"
        other-edit-permission-code="manufacturer.get"
    ></detail>
  </Layout>

</template>

